module.exports = __webpack_public_path__ + "img/soundDash.17b14c64.png";